import { useQuery } from '@tanstack/react-query';
import { Skeleton } from 'antd';
import { FC, ReactNode } from 'react';

import { Typography } from '@/shared/ui';

import api from '@/api';
import { queryKeys } from '@/api/queryKeys';

import { formatStatisticNumber } from '../../lib';

import './StatisticsStyles.scss';

export const Statistics: React.FC = () => {
  const { isLoading, data: statistics = [] } = useQuery({
    queryKey: queryKeys.services.statistics(),
    queryFn: () => api.getStatistics().then((r) => r.data),
  });

  const slicedStatistic = statistics.slice(0, 4);

  return (
    <section className="statistic">
      <Typography as="h2" visuallyHidden>
        Аналітичні показники сервісу
      </Typography>
      <div className="statistic__container container">
        {(isLoading || slicedStatistic.length === 0) &&
          Array.from({ length: 4 }, (_, idx) => idx).map((item) => <SkeletonStatisticItem key={item} />)}
        {!isLoading &&
          slicedStatistic.length > 0 &&
          slicedStatistic.map(([label, value]) => <StatisticItem key={label} label={label} value={Number(value)} />)}
      </div>
    </section>
  );
};

interface StatisticItemProps {
  label: ReactNode;
  value: ReactNode;
}

const StatisticItem: FC<StatisticItemProps> = ({ label, value }) => {
  return (
    <div className="statistic__item">
      <Typography as="h3" variant="H1" className="statistic__item-value">
        {typeof value === 'number' ? formatStatisticNumber(value) : value}
      </Typography>
      <Typography variant="TEXT16" className="statistic__item-label">
        {label}
      </Typography>
    </div>
  );
};

const SkeletonStatisticItem: React.FC = () => {
  return (
    <div className="statistic__item">
      <Skeleton.Input active size="default" className="statistic__item-value" />
      <Skeleton.Input active block size="small" className="statistic__item-label" />
    </div>
  );
};
